import React from 'react';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

// React view component to render
import { CSrOrderListNotesWorkFlowItemService } from 'services/cSROrderListNotesWorkFlowItem';
import { cSrOrderListNotesWorkFlowItem as CSrOrderListNotesWorkFlowItemView } from 'ui/views/widgets/cSROrderListNotesWorkFlowItem';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CsrOrderListNotesWorkFlowItem } from 'ui/containers/CSROrderListNotesWorkFlowItem';
 *
 * // render
 * <CsrOrderListNotesWorkFlowItem propName='propValue'/>
 */
export class CsrOrderListNotesWorkFlowItem extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        this.cSrOrderListNotesWorkFlowItemService = new CSrOrderListNotesWorkFlowItemService();

        this.fetchComponentData();

    }

    async fetchComponentData() {
        log.debug( 'CsrOrderListNotesLineItem.fetchComponentData()' );

        // cancel ongoing request
        this.cSrOrderListNotesWorkFlowItemService.cancel();

        try {
            const{ status, data }  = await this.cSrOrderListNotesWorkFlowItemService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CSrOrderListNotesWorkFlowItemView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                onCancelClick={ this.props.onCancelClick }
            />
        );
    }
}

// set display name
CsrOrderListNotesWorkFlowItem.displayName = 'CsrOrderListNotesWorkFlowItem';

// set default props
CsrOrderListNotesWorkFlowItem.defaultProps = {};

// prop types
CsrOrderListNotesWorkFlowItem.propTypes = {};
